import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class RoleCriteria extends BasicCriteria {
featureCodes: string[];
roleType: string;
visionCode: string;
visionCodeList: string[];
withoutAccessGrant: boolean | null;
withoutFeature: boolean | null;
withoutWildcard: boolean | null;
}

